/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  HomeProtocolsGetBrandAssetsResponse,
  HomeProtocolsGetHomeResponse,
  HomeProtocolsGetTaskDetailRequest,
  HomeProtocolsGetTaskDetailResponse,
  HomeProtocolsTaskDismissRequest,
  HomeProtocolsTaskGetDownloadUrlRequest,
  HomeProtocolsTaskGetDownloadUrlResponse,
  HomeProtocolsTaskGetUploadUrlRequest,
  HomeProtocolsTaskGetUploadUrlResponse,
  HomeProtocolsTaskSubmitRequest,
  MarqCommonProtocolEmptyRequest,
  MarqCommonProtocolEmptyResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Home<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Home
   * @name HomeList
   * @request GET:/home
   */
  homeList = (params: RequestParams = {}) =>
    this.http.request<HomeProtocolsGetHomeResponse, any>({
      path: `/home`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Home
   * @name TaskDetailCreate
   * @request POST:/home/task/detail
   */
  taskDetailCreate = (data: HomeProtocolsGetTaskDetailRequest, params: RequestParams = {}) =>
    this.http.request<HomeProtocolsGetTaskDetailResponse, any>({
      path: `/home/task/detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Home
   * @name TaskSubmitCreate
   * @request POST:/home/task/submit
   */
  taskSubmitCreate = (data: HomeProtocolsTaskSubmitRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/home/task/submit`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Home
   * @name TaskDismissCreate
   * @request POST:/home/task/dismiss
   */
  taskDismissCreate = (data: HomeProtocolsTaskDismissRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/home/task/dismiss`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Home
   * @name TaskUploadUrlCreate
   * @request POST:/home/task/upload-url
   */
  taskUploadUrlCreate = (data: HomeProtocolsTaskGetUploadUrlRequest, params: RequestParams = {}) =>
    this.http.request<HomeProtocolsTaskGetUploadUrlResponse, any>({
      path: `/home/task/upload-url`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Home
   * @name TaskDownloadUrlCreate
   * @request POST:/home/task/download-url
   */
  taskDownloadUrlCreate = (data: HomeProtocolsTaskGetDownloadUrlRequest, params: RequestParams = {}) =>
    this.http.request<HomeProtocolsTaskGetDownloadUrlResponse, any>({
      path: `/home/task/download-url`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Home
   * @name BrandAssetsList
   * @request GET:/home/brand-assets
   */
  brandAssetsList = (params: RequestParams = {}) =>
    this.http.request<HomeProtocolsGetBrandAssetsResponse, any>({
      path: `/home/brand-assets`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Home
   * @name UrlContactSalesCreate
   * @request POST:/home/url/contact-sales
   */
  urlContactSalesCreate = (data: MarqCommonProtocolEmptyRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/home/url/contact-sales`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
